let levels = [];
const NUMBER_OF_LEVELS = 16;
const INITIAL_WEIGHT = 100;

for (let i = 0; i < NUMBER_OF_LEVELS; i++) {
  levels.push({item: i + 1,  weight: INITIAL_WEIGHT + i * 7});
}

export default levels;
